<template>
    <div class="page-root">
        <backdrop-loader :isLoading="loading"/>
        <div class="content">
            <div style="display: flex; justify-content: space-between; padding-bottom: 15px;">
                <div class="header">
                    <h3 class="title">Lookup Values</h3>
                    <p class="subtitle">
                        <a :href="formulaDetailsLink">{{ subtitle }}</a>
                    </p>
                </div>
                <div class="header-links">
                    <a :href="goBackLink">
                        <i class="fa fa-arrow-left"></i> Go Back
                    </a>
                    <a :href="projectionsLink" target="_blank" v-if="pipelineSlug === 'shadow'">
                        <div class="variable-btn">
                            <button data-v-4ab46356="" class="v2_btn v2_btn-primary v2_btn-transparent">
                                Projections
                            </button>
                        </div>
                    </a>
                </div>
            </div>
            <div v-if="lookupVariables">
                <Tabs class="tabs-root" :theme="theme">
                    <TabItem :name="v.name" :key="v.id" v-for="v in lookupVariables">
                        <div class="tab-content">
                            <lookup-values-form
                                :is-editable="!formulaEntity.has_gone_live || pipelineSlug === 'shadow'"
                                :variable=v
                                :variable-link="getVariableLink(v.id)"
                                :variables="variables"
                                :show-description="canShowDescription(v.name)"
                            />
                        </div>
                    </TabItem>
                </Tabs>
            </div>
        </div>
    </div>
</template>

<script>
import {Tabs, TabItem} from 'vue-material-tabs'
import {mapGetters, mapState, mapActions} from 'vuex'

import store from './store'
import PriceMixin from './shared/formula.mixin'
import LookupValuesForm from './shared/lookup-form'
import BackdropLoader from '../utils/backdrop-loader'

export default {
    store,
    components: {
        Tabs,
        TabItem,
        BackdropLoader,
        LookupValuesForm,
    },
    mixins: [PriceMixin],
    props: {
        pipelineSlug: {
            required: true,
        },
        formulaId: {
            required: true,
        },
        refererUrl: {
            default: null,
            required: false,
        },
        adSetOptions: {
            default: () => ({}),
            required: false,
        },
    },
    data: function () {
        return {
            theme: {
                navActiveItem: '#4e63ff',
                slider: '#4e63ff',
                arrow: '#4e63ff',
            },
        }
    },
    computed: {
        ...mapState(['loading', 'formulaEntity']),
        ...mapGetters(['variables', 'lookupVariables', 'pipelineLabel', 'verticalName']),
        subtitle: function () {
            return `${this.verticalName} ${this.pipelineLabel} Formula Id: ${this.$store.state.formulaId}`
        },
        goBackLink() {
            return this.refererUrl || this.formulaDetailsLink
        },
        formulaDetailsLink() {
            return `/manage/resources/${this.pipelineSlug}-formula/${this.formulaId}`
        },
        projectionsLink() {
            return `/formula/${this.pipelineSlug}/${this.formulaId}/projections`
        }
    },
    methods: {
        ...mapActions(['fetchFormula']),
        canShowDescription(lookupVariableName) {
            return true
            // return [
            //     'CD_Ceiling',
            //     'CD_Floor',
            //     'CD_PriceLevel',
            //     'SMMA_Ceiling',
            //     'SMMA_Floor',
            //     'SMMA_PriceLevel'
            // ].includes(lookupVariableName)
        },
        getVariableLink(id) {
            return `/manage/resources/${this.pipelineSlug}-variable/${id}`
        }
    },
    created: function () {
        this.$store.commit('setFormulaId', this.formulaId)
        this.$store.commit('setPipelineSlug', this.pipelineSlug)

        this.fetchFormula({
            formulaId: this.$store.state.formulaId,
            pipelineSlug: this.$store.state.pipelineSlug,
        })
    },
}
</script>

<style scoped>
.page-root {
    display: flex;
    justify-content: center;
}

.content {
    width: 100%;
    min-height: 80vh;
    overflow: hidden;
    max-width: 1600px;
}

.header {
    display: flex;
    gap: 8px;
    margin-left: 40px;
}

@media (max-width: 1440px) {
    .header {
        flex-direction: row;
        align-items: baseline;
    }
}

.title {
    margin-bottom: 0;
    margin-top: 0;
    margin-right: 32px;
}

.tabs-root >>> .tabs__content {
    padding: 0 40px;
}

.tabs-root >>> .vmt__nav__item {
    font-size: 13px !important;
    font-weight: 600 !important;
    text-transform: none !important;
    margin-right: 4px;
    border: solid 0.5px #e5e5e5;
    border-bottom: none;
}

.tabs-root >>> .vmt__nav__items {
    border-bottom: solid 0.5px #e5e5e5;
}

.tab-content {
    padding: 16px 17px;
    border: solid 0.5px #e5e5e5;
}

.paper {
    border-radius: 4px;
    padding: 16px;
    background-color: white;
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 2px 4px 0px,
    rgb(0 0 0 / 12%) 0px 1px 8px 0px;
}

.header-links {
    display: flex;
    justify-content: space-between;
    margin-right: 20px;
}

.header-links a:first-child {
    padding-top: 6px;
    margin-right: 20px;
}

.variable-btn {
    align-items: center;
    justify-content: space-between;
    margin-right: 20px;
    margin-top:2px;
}
</style>
